export enum Permission {
  IntegrationsView = 'integrations.view',
  IntegrationsModify = 'integrations.modify',
}
